<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Keyword -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Club Name (optional)</h2>
    <div class="filter-list__group-content">
      <input id="flyingClubName" type="text" class="landing-page__field landing-page__query-field"
             [(ngModel)]="flyingClubFinderFilter.name" (input)="onNameChange()"
             aria-label="Club Name" autocomplete="off" autocorrect="off"
             [attr.aria-invalid]="nameTooShort ? true : null"
             [attr.aria-describedby]="nameTooShort ? 'flyingClubNameError' : null">
      <div *ngIf="nameTooShort" id="flyingClubNameError" class="flying-club-filter__validation-message" role="alert">
        Please enter at least three characters to search by club name.
      </div>
    </div>
  </div>
</div>

<div class="filter-list" [class.filter-list--events-compact]="compact">
  <!-- Club Type -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Club Type</h2>
    <div class="filter-list__group-content">
      <div class="filter">
        <mat-checkbox [(ngModel)]="flyingClubFinderFilter.aopaNetwork" (change)="onToggleClubType()"
                      aria-label="AOPA Network Club" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">AOPA Network Club</span></div>
        </mat-checkbox>
      </div>
      <div class="filter">
        <mat-checkbox [(ngModel)]="flyingClubFinderFilter.inFormation" (change)="onToggleClubType()"
                      aria-label="Club In Formation" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">Club In Formation</span></div>
        </mat-checkbox>
      </div>
      <div class="filter">
        <mat-checkbox [(ngModel)]="flyingClubFinderFilter.equityClub" (change)="onToggleClubType()"
                      aria-label="Equity Club" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">Equity Club</span></div>
        </mat-checkbox>
      </div>
      <div class="filter">
        <mat-checkbox [(ngModel)]="flyingClubFinderFilter.nonEquityClub" (change)="onToggleClubType()"
                      aria-label="Non-Equity Club" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">Non-Equity Club</span></div>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Membership (OR logic) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Membership</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAll('membership', membershipOptions)">Select All</span> |
      <span class="filter-list__group-button" (click)="onClearAll('membership')">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter" *ngFor="let option of membershipOptions">
        <mat-checkbox [checked]="isFacetSelected('membership', option.value)"
                      (change)="onToggleFacet('membership', option.value, $event.checked)"
                      [attr.aria-label]="option.label" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Benefits (AND logic) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Benefits</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAll('benefits', benefitsOptions)">Select All</span> |
      <span class="filter-list__group-button" (click)="onClearAll('benefits')">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter" *ngFor="let option of benefitsOptions">
        <mat-checkbox [checked]="isFacetSelected('benefits', option.value)"
                      (change)="onToggleFacet('benefits', option.value, $event.checked)"
                      [attr.aria-label]="option.label" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
        </mat-checkbox>
      </div>
    </div>
  </div>

  <!-- Types of Flying (AND logic) -->
  <div class="filter-list__group">
    <h2 class="filter-list__group-header">Types of Flying</h2>
    <div class="filter-list__group-buttonbar">
      <span class="filter-list__group-button" (click)="onSelectAll('flying', flyingOptions)">Select All</span> |
      <span class="filter-list__group-button" (click)="onClearAll('flying')">Clear All</span>
    </div>
    <div class="filter-list__group-content">
      <div class="filter" *ngFor="let option of flyingOptions">
        <mat-checkbox [checked]="isFacetSelected('flying', option.value)"
                      (change)="onToggleFacet('flying', option.value, $event.checked)"
                      [attr.aria-label]="option.label" class="filter__checkbox">
          <div class="filter__header"><span class="filter__label">{{ option.label }}</span></div>
        </mat-checkbox>
      </div>
    </div>
  </div>

</div>
